import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade } from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/autoplay';
import 'swiper/css/effect-fade';


new Swiper('.swiper', {
    // configure Swiper to use modules
    modules: [Navigation, Pagination],
    direction: 'horizontal',
    // Navigation arrows
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    pagination: {
        el: ".swiper-pagination",
        type: "fraction",
    },
});

new Swiper('.swiper-gallery', {
    // configure Swiper to use modules
    modules: [Autoplay, EffectFade],
    slidesPerView: 1,
    effect: 'fade',
    fadeEffect: { crossFade: true },
    loop: true,
    autoplay: { delay: 3500, disableOnInteraction: false, },
    speed: 500,
});
